<template>
    <div v-show="noActiveContractsIsOn" name="modal">
        <div class="modal modal-mask small-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">

                    <!-- Header -->

                    <div class="modal-header">
                        <h3 class="modal-title">Request Support</h3>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="close">
                            <span aria-hidden="true" class="icon-x"></span>
                        </button>
                    </div>

                    <!-- Body -->

                    <div class="modal-body">
                        <div class="modal-question fix" >
                            <p style="margin-bottom:0;">Please call us at <a href="tel:+442083464300">+44 20 83464300</a> and we’ll be happy to assist!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NoActiveContractsSupportDialog",

        data(){
            return{
                noActiveContractsIsOn: false
            }
        },

        methods: {
            show(){
                this.noActiveContractsIsOn = true;
            },

            close(){
                this.noActiveContractsIsOn = false;
            }
        }
    };
</script>